export const PROCESSED_TYPE_OPTIONS = [
  { label: 'Все', value: 'all' },
  { label: 'Обработанные', value: 'processed' },
  { label: 'Не обработанные', value: 'not_processed' },
]

export const SORTABLE_COLUMNS = [
  'student_name',
  'parent_name',
  'uploaded_at',
  'contract_end_date',
  'name',
  'signing_state',
  'file_path',
  'sent_for_signature_at',
] as const

export const RECIPIENT_TYPE_OPTIONS = [
  { label: 'Авто', value: 'auto' },
  { label: 'Учащийся', value: 'student' },
  { label: 'Родитель', value: 'parent' },
]

export const SEND_FOR_SIGNATURE_PDF_ONLY_TOOLTIP =
  'Данный файл нельзя отправить на подписание, так как он загружен не в формате PDF.'

export const SEND_FOR_SIGNATURE_TOOLTIP = 'Отправить на подпись клиенту'

export const PODPISLON_NOT_CONNECTED_TOOLTIP =
  'Вы не можете отправить документ на электронное подписание, так как у вас не подключена интеграция с сервисом Подпислон в разделе «Настройки платформы» – «Интеграции»'

export const SEND_FOR_SIGNATURE_SIGNED_TOOLTIP =
  'Договор уже подписан'

export const SEND_FOR_SIGNATURE_PENDING_TOOLTIP =
  'Документ уже отправлен на подписание'

export const SEND_FOR_SIGNATURE_NOT_REQUIRED_TOOLTIP =
  'Договор не требует подписания'

export const SEND_FOR_SIGNATURE_SIGNER_PHONE_HINT =
  'На этот номер будет отправлен код для подписания документа. После его подписания вы увидите данный статус в таблице'

export const SEND_FOR_SIGNATURE_PARENT_HINT =
  'Включив данный чекбокс, вы можете выбрать любого привязанного родителя к этому учащемуся, и подтянутся все данные этого родителя.'

export const SEND_FOR_SIGNATURE_MANUAL_PHONE_FORMAT_HINT =
  'Укажите номер в одном из форматов:\n+7 (900) 123-45-67\n8 (900) 123-45-67\n89001234567\n+79001234567'

export const END_DATE_COLUMN_HINT =
  'Вы можете добавить дату завершения данного документа, а также отметить обработан он или нет. Тогда в отдельном отчете по договорам вы сможете увидеть, какие договоры уже завершены, а какие нет. Какие обработаны, а какие нет.'
